import { useCallback, useEffect, useMemo, useState } from 'react';

const BREAKPOINT_RULES = {
  mobile: { max: 999 },
  desktop: { min: 1000 },
  tablet: { min: 641, max: 1007 },
};

function matchesBreakpoint({ min, max } = {}, width) {
  if (min != null && width < min) return false;
  if (max != null && width > max) return false;
  return true;
}

export default function DisplayAt({ value, children }) {
  const rule = useMemo(() => BREAKPOINT_RULES[value], [value]);
  const hasWindow = typeof window !== 'undefined';
  const [isClientReady, setIsClientReady] = useState(hasWindow);

  const computeMatch = useCallback(() => {
    if (typeof window === 'undefined') return false;
    return matchesBreakpoint(rule, window.innerWidth);
  }, [rule]);

  const [isVisible, setIsVisible] = useState(() => (isClientReady ? computeMatch() : false));

  useEffect(() => {
    if (!isClientReady) {
      setIsClientReady(true);
      return;
    }

    const onResize = () => setIsVisible(computeMatch());

    onResize();
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, [computeMatch, isClientReady]);

  if (!isVisible) return null;

  return <>{typeof children === 'function' ? children() : children}</>;
}
